module.exports = __webpack_public_path__ + "static/media/BEL-BNB.2634b528.svg";